import React from "react";
import { ConfirmModal } from "../../../../../../../../boxes/ConfirmModal/ConfirmModal";

export const ModalUnblock = ({ onSubmit, onClose, isSubmitting }) => (
  <ConfirmModal
    isOpen
    onClose={onClose}
    onCancel={onClose}
    onConfirm={() => onSubmit().then(onClose)}
    isConfirming={isSubmitting}
  >
    Are you sure you want to Unblock this user?
  </ConfirmModal>
);
